import React, { useState, useRef, useEffect } from "react";
import { View, TouchableOpacity, Animated, StyleSheet } from "react-native";
import variables from "src/merchant/assets/variables";

const Switch = ({ value, onSwitch }) => {
  const switchAnimatedValue = useRef(new Animated.Value(value ? 1 : 0)).current;
  const animate = (value) => {
    Animated.timing(switchAnimatedValue, {
      toValue: value ? 1 : 0,
      duration: 200,
      useNativeDriver: false,
    }).start();
  };

  const switchTranslateX = switchAnimatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [3, 19],
  });

  useEffect(() => {
    animate(value)
  }, [value]);

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      onPress={()=>onSwitch(!value)}
      style={styles.container}
    >
      <View style={styles.track} />
      <Animated.View
        style={[
          styles.thumb,
          { transform: [{ translateX: switchTranslateX }] },
        ]}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
  },
  track: {
    width: 40,
    height: 22,
    borderRadius: 11,
    backgroundColor: "#D9D9D9",
  },
  thumb: {
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: variables.$brandColor,
    position: "absolute",
  },
});

export default Switch;
